import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import cashhero from '@/plugins/cashhero'
import { errorsRouters } from '@/routers/errors'
import { primaryRouters } from '@/routers/primary'
import { secondaryRouters } from '@/routers/secondary'

Vue.use(Router)
Vue.use(cashhero)

const getRouter = (store) => {
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      primaryRouters,
      secondaryRouters,
      errorsRouters
    ]
  })

  const handleUserData = (to, from, next, callback) => {
    /**
     * If no user data, we need to fetch it first
     */
    if (!store.state.user.data) {
      const _token = localStorage.getItem(process.env.VUE_APP_TOKEN)
      /**
       * Token must be defined in localstorage in order to fetch user data,
       * Otherwise, it will redirect to login page
       */
      if (_token) {
        axios.post(process.env.VUE_APP_API + '/api/v1/user/get-roles-and-permissions')
          .then((response) => {
            if (response.data && response.data.data) {
              const result = response.data.data
              store.dispatch('user/setUser', { user: result.user })
              // store roles
              store.dispatch('user/setRoles', result.roles)
              // store permission
              store.dispatch('user/setPermissions', result.permissions)
              // callback
              callback()
            }
          })
          .catch((error) => {
            if (error.response && error.response.status) {
              const statusCode = error.response.status
              if (statusCode === 401) {
                localStorage.removeItem(process.env.VUE_APP_TOKEN)
                localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN)
                store.dispatch('user/clearUser')
                next({ name: 'login' })
              } else {
                localStorage.removeItem(process.env.VUE_APP_TOKEN)
                localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN)
                store.dispatch('user/clearUser')
                next({ name: 'login' })
              }
            } else {
              next()
            }
          })
      } else {
        localStorage.removeItem(process.env.VUE_APP_TOKEN)
        localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN)
        store.dispatch('user/clearUser')
        next({ name: 'login' })
      }
    } else {
      callback()
    }
  }

  router.beforeEach((to, from, next) => {
    if (document.querySelector('.wrapper')) {
      document.querySelector('.wrapper').scrollTo(0, 0)
    }
    /**
     * User should go to login page when already login
     */
    if (to.name === 'login' && localStorage.getItem(process.env.VUE_APP_TOKEN)) {
      next({ name: 'dashboard', replace: true })
      return
    }

    /**
     * Need to defined noAuth meta on unprotected route
     * Any unprotected route, no need to check, just proceed
     */
    if (to.meta.noAuth) {
      next()
      return
    }

    handleUserData(to, from, next, () => {
      const userRoles = store.state.user.data.roles || []
      let rolesQualified = true
      if (!store.getters['user/isAdmin']) {
        for (const route of to.matched) {
          const qualifiedAtRoute = route.meta.roles ? userRoles.some(role => route.meta.roles.includes(role)) : true
          if (!qualifiedAtRoute) {
            rolesQualified = false
            break
          }
        }
      }

      let permissionsQualified = true
      if (rolesQualified) {
        const userPermissions = store.state.user.data.permissions || []
        if (!store.getters['user/isAdmin']) {
          for (const route of to.matched) {
            const qualifiedAtRoute = route.meta.permissions ? userPermissions.some(permission => route.meta.permissions.includes(permission)) : true
            if (!qualifiedAtRoute) {
              permissionsQualified = false
              break
            }
          }
        }
      }

      if (rolesQualified && permissionsQualified) {
        next()
      } else {
        next({ name: 'unauthorized' })
      }
    })
  })
  return router
}

export default getRouter
